import script from "./tourists.vue?vue&type=script&lang=ts&setup=true"
export * from "./tourists.vue?vue&type=script&lang=ts&setup=true"

import "./tourists.vue?vue&type=style&index=0&id=908b2bb2&lang=scss&scoped=true"
import "./tourists.vue?vue&type=style&index=1&id=908b2bb2&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-908b2bb2"]])

export default __exports__